import { ErrorComponentProps, isNotFound } from '@tanstack/react-router'

import { NotConnected } from './NotConnected'
import { NotFoundComponent } from './NotFoundComponent'
import { UnknownError } from './UnknownError'
import { NotConnectedError } from '@/domain/errors/not-connected'

export function ErrorComponent({ ...props }: ErrorComponentProps) {
  if (isNotFound(props.error)) {
    return <NotFoundComponent isNotFound routeId={props.error.routeId ?? '/'} />
  }

  if (props.error instanceof NotConnectedError) {
    return <NotConnected />
  }

  return <UnknownError {...props} />
}
